import { Injectable } from '@angular/core';
import { ComponentBase } from '../component-base';
import { StageService } from './stage.service';
import { SceneUtilsService } from './scene-utils.service';
import { EventLogService, Actions } from '../services/eventLog';
import { AutoScaleSprite } from '../custom/AutoScaleSprite';
declare const THREE: any;

@Injectable()
export class RemoveWallService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private eventLog: EventLogService
  ) {
    super();
    this.disable();
  }

  sprites = [];
  loader = new THREE.TextureLoader();
  isActive = false;
  private raycaster: any = new THREE.Raycaster(new THREE.Vector3(), new THREE.Vector3(0, -1, 0));

  drawSprites() {
    const walls = this.stage.getWalls();

    for (let i = 0; i < walls.length; i++) {
      const wall = walls[i];
      const spriteMap = this.loader.load('../../assets/images/sprites/remove.png');

      const spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

      const sprite = new AutoScaleSprite(50, 50, spriteMaterial);
      sprite.userData.wall = wall;
      sprite.position.set(
        wall.getWorldPosition(new THREE.Vector3()).x,
        wall.getWorldPosition(new THREE.Vector3()).y + wall.parent.getWorldPosition(new THREE.Vector3()).y / 2,
        wall.getWorldPosition(new THREE.Vector3()).z
      );

      this.sprites.push(sprite);
      this.stage.add(sprite);
    }
  }

  mouseDown(e) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    const intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      const wall = intersection[0].object.userData.wall;
      this.eventLog.dispatch(new Actions.DeleteWallAction(wall));
      this.removeSprites();
    }
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites = [];
  }

  disable() {
    this.removeSprites();
    super.disable();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remove-wall.service.ts